const childRoutes = (prop) => [
  {
    path: 'promotion-dashboard',
    name: prop + '.promotion_dashboard',
    meta: { auth: true },
    component: () => import('../pages/promotion-dashboard/List.vue')
  },
  {
    path: 'promotion-entry',
    name: prop + '.promotion_entry',
    meta: { auth: true },
    component: () => import('../pages/promotion-entry/List.vue')
  },
  {
    path: 'promotion-view',
    name: prop + '.promotion_view',
    meta: { auth: true },
    component: () => import('../pages/promotion-view/List.vue')
  }
]
const routes = [{
  path: '/production-service/promotion-management',
  name: 'production_service.promotion_management',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.promotion_management')
}]

export default routes
